export default {"src":"/_next/static/media/sloped.6d0bf748.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};